import { EVENT_FIELDS, EVENT_ORIGIN } from "../../constants/analytics.es.js";
import { p as pickFields } from "../../../pickFields-27454ddf.js";
const extractEventData = (payload, application) => {
  const picked = pickFields([EVENT_FIELDS.EVENT_ID], payload.properties);
  return {
    // Default event_origin to "client"
    [EVENT_FIELDS.EVENT_ORIGIN]: payload.properties[EVENT_FIELDS.EVENT_ORIGIN] || EVENT_ORIGIN.CLIENT,
    ...picked,
    application,
    [EVENT_FIELDS.EVENT_DATETIME]: payload.meta.timestamp,
    [EVENT_FIELDS.EVENT_TYPE]: payload.type
  };
};
export {
  extractEventData
};
